/** STIX Two Text — closest web equivalent to LaTeX body text. */
export const METHODOLOGY_FONT_FAMILY = '"STIX Two Text", "Latin Modern Roman", "Computer Modern", serif';

export const METHODOLOGY_ARTICLE_MAX_W = '42rem';

export const METHODOLOGY_ARTICLE_PX = { base: 5, md: 10 } as const;

export const METHODOLOGY_ARTICLE_PT = { base: 2, md: 4 } as const;

export const METHODOLOGY_ARTICLE_PB = { base: 8, md: 12 } as const;

export const METHODOLOGY_SECTION_SPACING = 10;

/** Body copy, bullets, accordion triggers, non-compact markdown. */
export const METHODOLOGY_BODY_FONT_SIZE = { base: 'sm', md: 'md' } as const;

/** Section titles and same-level labels (Prompt, Interpretation, …). */
export const METHODOLOGY_SECTION_TITLE_FONT_SIZE = { base: 'md', md: 'lg' } as const;

/** Major part titles (AI Models Swap Teams, Original List Challenge). */
export const METHODOLOGY_MAJOR_TITLE_FONT_SIZE = { base: 'xl', md: '2xl' } as const;

/** Prompt inset / compact markdown — one step below body. */
export const METHODOLOGY_COMPACT_FONT_SIZE = { base: 'xs', md: 'sm' } as const;
